
import React from "react";
import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { iconos } from "../../../data";




export const TarjetasOpciones = ({ onClickHandler, url, icono, titulo, subtitulo }) => {

    return (

        <Grid item xs={6} sm={4} md={3} lg={2.4}>
            <Card elevation={3} sx={{width:'100%', display:'flex', flexDirection:'column', borderRadius:'20px', height:'100%'}}>
                <CardActionArea onClick={() => onClickHandler?.(url) || null}
                    sx={{height:'100%',display: 'flex', flexDirection:'column', justifyContent:'center', py:1}} 
                >
                    <CardContent sx={{ textAlign:'center', width:'100%', overflow:'hidden' }}>
                        { React.cloneElement(iconos[icono], {sx:{
                            fontSize: { xs: 50, sm: 55, md: 60 },
                            color: icono === 'eliminar' ? '#ff1744' : 'secondary.main'
                        }})}
                        <Typography sx={{ fontSize: {xs:'0.7rem', sm:'0.9rem'}, fontWeight:700, lineHeight:1.2,
                            wordBreak:'break-word', color:'white', mb:0.5, mt:1
                        }}>
                            { titulo }
                        </Typography>

                        {(subtitulo) && 
                            <Typography sx={{ fontSize:{xs:'0.7rem', sm:'0.9rem'}, fontWeight:600, lineHeight:1.2, 
                                wordBreak:'break-word', color:'#424242'
                            }}>
                                { subtitulo }
                            </Typography>}
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>

    )
}
